import type Entry from 'garaje/models/entry';
import type Invite from 'garaje/models/invite';

export function needsLocationApprovalReview(model: Invite | Entry): boolean {
  if (model.visitApproval?.prioritizedStatus !== 'review') return false;

  return model.visitApproval.reviewResults.some((results) => {
    if (results.isBlocklist()) return results.isLocationBlocklist;
    return true;
  });
}

export function needsPropertyApprovalReview(model: Invite | Entry): boolean {
  if (model.visitApproval?.prioritizedStatus !== 'review') return false;

  return model.visitApproval.reviewResults.some((results) => {
    if (results.isBlocklist()) return results.isPropertyBlocklist;
    return false;
  });
}
